import pathOr from 'ramda/src/pathOr'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

export default (state, { moduleId, fieldDescPath }) => pathOr(
	false,
	[moduleId, ...fieldDescPath, 'fieldMinValue'],
	moduleDescriptions,
)
